export const LOGON_PAGE = "/logon";
export const LOGOUT_PAGE = "/logout";
export const UPDATE_PASSWORD_PAGE = "/logon/update-password";
export const RESET_PASSWORD_PAGE = "/logon/reset-password";
export const SET_NEW_PASSWORD_PAGE = "/logon/set-new-password";
export const APP_PAGE = "/app";
export const APP_UPDATES_PAGE = "/app/updates";
export const PLATFORMS = "/platforms";
export const NOT_FOUND = "/404";